import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDateStruct, NgbDatepickerNavigateEvent, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { FormlyModule } from '@ngx-formly/core';

import { FormlyFieldBaseComponent } from '../formly-field-base.component';

@Component({
  selector: 'app-formly-date',
  templateUrl: './formly-date.component.html',
  styleUrl: './formly-date.component.scss',
  imports: [NgbInputDatepicker, FormsModule, ReactiveFormsModule, FormlyModule],
})
export class FormlyDateComponent extends FormlyFieldBaseComponent {
  private readonly today = new Date();

  // The year the +/- range is centred on. Starts at the current year and re-centres on
  // whatever year the user navigates/selects, so they can keep moving outwards indefinitely. The
  // window is deliberately kept small so the (native) year dropdown stays short — re-centring, not a
  // huge window, provides the reach. A field can widen/narrow the span via
  // props.yearsBefore / props.yearsAfter.
  private centreYear = this.today.getFullYear();

  private get yearsBefore(): number {
    return this.props.yearsBefore ?? 15;
  }

  private get yearsAfter(): number {
    return this.props.yearsAfter ?? 15;
  }

  get minDate(): NgbDateStruct {
    return { year: this.centreYear - this.yearsBefore, month: 1, day: 1 };
  }

  get maxDate(): NgbDateStruct {
    return { year: this.centreYear + this.yearsAfter, month: 12, day: 31 };
  }

  // Only steer the initial view when the field is EMPTY (open on the current month/year). When the
  // field already has a value, return undefined so the datepicker opens on that value rather than
  // being forced to today.
  get startDate(): NgbDateStruct | undefined {
    return this.formControl?.value
      ? undefined
      : { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: 1 };
  }

  // Re-centre the +/- range on the year the user navigated to (opening on a valued field fires this
  // too, so the range also recentres on the field's own year).
  navigate(event: NgbDatepickerNavigateEvent) {
    if (event?.next?.year && event.next.year !== this.centreYear) {
      this.centreYear = event.next.year;
    }
  }

  change() {
    if (this.props.change) {
      this.props.change(this.field, { target: { value: this.field.model[this.key] } });
    }
  }
}
